import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "PreTripStatusIcon"
}
const _hoisted_2 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.3029 5.23074L16.5557 5.4836C16.6896 5.61755 16.7649 5.79919 16.7649 5.9886C16.7649 6.178 16.6896 6.35965 16.5557 6.4936L8.36288 14.6865C8.22893 14.8204 8.04729 14.8956 7.85788 14.8956C7.66848 14.8956 7.48683 14.8204 7.35288 14.6865L3.80288 11.1365C3.66898 11.0025 3.59375 10.8209 3.59375 10.6315C3.59375 10.4421 3.66898 10.2604 3.80288 10.1265L4.05574 9.8736C4.18969 9.73969 4.37134 9.66446 4.56074 9.66446C4.75014 9.66446 4.93179 9.73969 5.06574 9.8736L7.35288 12.1607C7.48683 12.2946 7.66848 12.3699 7.85788 12.3699C8.04729 12.3699 8.22893 12.2946 8.36288 12.1607L15.2929 5.23074C15.4268 5.09683 15.6085 5.02161 15.7979 5.02161C15.9873 5.02161 16.1689 5.09683 16.3029 5.23074Z",
  fill: "#0BCC41"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.2887 14.9617C16.4649 15.1379 16.5638 15.3767 16.5638 15.6258C16.5638 15.8749 16.4649 16.1137 16.2887 16.2899C16.1126 16.466 15.8737 16.5649 15.6247 16.5649C15.3756 16.5649 15.1367 16.466 14.9606 16.2899L10.0005 11.3281L5.03874 16.2883C4.86262 16.4644 4.62374 16.5634 4.37467 16.5634C4.1256 16.5634 3.88673 16.4644 3.71061 16.2883C3.53449 16.1122 3.43555 15.8733 3.43555 15.6242C3.43555 15.3752 3.53449 15.1363 3.71061 14.9602L8.67233 10L3.71217 5.0383C3.53605 4.86218 3.43711 4.62331 3.43711 4.37423C3.43711 4.12516 3.53605 3.88629 3.71217 3.71017C3.88829 3.53405 4.12716 3.43511 4.37624 3.43511C4.62531 3.43511 4.86418 3.53405 5.0403 3.71017L10.0005 8.67189L14.9622 3.70939C15.1383 3.53327 15.3772 3.43433 15.6262 3.43433C15.8753 3.43433 16.1142 3.53327 16.2903 3.70939C16.4664 3.88551 16.5654 4.12438 16.5654 4.37345C16.5654 4.62252 16.4664 4.86139 16.2903 5.03751L11.3286 10L16.2887 14.9617Z",
  fill: "#FF0300"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.3009 5.23074L16.5538 5.4836C16.6877 5.61755 16.7629 5.79919 16.7629 5.9886C16.7629 6.178 16.6877 6.35965 16.5538 6.4936L8.36093 14.6865C8.22698 14.8204 8.04533 14.8956 7.85593 14.8956C7.66653 14.8956 7.48488 14.8204 7.35093 14.6865L3.80093 11.1365C3.66702 11.0025 3.5918 10.8209 3.5918 10.6315C3.5918 10.4421 3.66702 10.2604 3.80093 10.1265L4.05379 9.8736C4.18774 9.73969 4.36938 9.66446 4.55879 9.66446C4.74819 9.66446 4.92984 9.73969 5.06379 9.8736L7.35093 12.1607C7.48488 12.2946 7.66653 12.3699 7.85593 12.3699C8.04533 12.3699 8.22698 12.2946 8.36093 12.1607L15.2909 5.23074C15.4249 5.09683 15.6065 5.02161 15.7959 5.02161C15.9853 5.02161 16.167 5.09683 16.3009 5.23074Z",
  fill: "#808182"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 3,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.49372 3.00019C5.36401 3.00406 5.24091 3.05831 5.15048 3.1514L3.15346 5.14876C3.10683 5.19517 3.06982 5.25029 3.04457 5.31104C3.01932 5.3718 3.00632 5.43695 3.00632 5.50274C3.00632 5.56854 3.01932 5.63368 3.04457 5.69444C3.06982 5.75519 3.10683 5.81037 3.15346 5.85678L5.15048 7.8542C5.19616 7.90369 5.25137 7.94338 5.31279 7.97098C5.37422 7.99858 5.44059 8.01347 5.50792 8.01475C5.57525 8.01603 5.64214 8.00367 5.70457 7.97842C5.767 7.95317 5.82368 7.91559 5.87119 7.86787C5.91871 7.82014 5.95608 7.76328 5.98107 7.70074C6.00605 7.63819 6.01813 7.57124 6.01657 7.50391C6.01501 7.43657 5.99985 7.37024 5.972 7.30892C5.94415 7.2476 5.90418 7.19257 5.85451 7.1471L4.71169 6.00407H12.4921C12.6226 6.0012 12.7468 5.94734 12.8381 5.85401C12.9293 5.76068 12.9805 5.63527 12.9805 5.5047C12.9805 5.37414 12.9293 5.24878 12.8381 5.15545C12.7468 5.06212 12.6226 5.00826 12.4921 5.00539H4.70778L5.85451 3.85844C5.92687 3.78848 5.9764 3.69829 5.99661 3.59967C6.01682 3.50106 6.00676 3.39864 5.96775 3.30584C5.92874 3.21305 5.8626 3.1342 5.77801 3.07966C5.69342 3.02512 5.59433 2.99742 5.49372 3.00019ZM10.4941 7.99463C10.3945 7.99464 10.2972 8.02442 10.2147 8.08015C10.1322 8.13588 10.0682 8.21495 10.031 8.30731C9.99381 8.39968 9.98506 8.50106 10.0059 8.59843C10.0267 8.69581 10.0762 8.78475 10.1479 8.8538L11.2907 9.99585H3.51035C3.44387 9.99439 3.37776 10.0062 3.31591 10.0307C3.25405 10.0551 3.1977 10.0917 3.15017 10.1382C3.10263 10.1847 3.06486 10.2402 3.03907 10.3016C3.01328 10.3629 3 10.4287 3 10.4952C3 10.5617 3.01328 10.6276 3.03907 10.6889C3.06486 10.7502 3.10263 10.8057 3.15017 10.8523C3.1977 10.8988 3.25405 10.9353 3.31591 10.9598C3.37776 10.9842 3.44387 10.996 3.51035 10.9945H11.2946L10.1479 12.1415C10.1002 12.1876 10.0621 12.2428 10.0359 12.3039C10.0098 12.3649 9.99606 12.4306 9.99558 12.497C9.99511 12.5634 10.0079 12.6293 10.0332 12.6907C10.0584 12.7521 10.0957 12.8079 10.1428 12.8547C10.1899 12.9015 10.2458 12.9385 10.3074 12.9635C10.3689 12.9884 10.4348 13.0008 10.5012 13C10.5676 12.9991 10.6332 12.985 10.6941 12.9585C10.755 12.932 10.81 12.8936 10.8558 12.8456L12.8529 10.8512C12.8995 10.8048 12.9365 10.7496 12.9617 10.6889C12.987 10.6281 13 10.563 13 10.4972C13 10.4314 12.987 10.3662 12.9617 10.3055C12.9365 10.2447 12.8995 10.1895 12.8529 10.1431L10.8558 8.14578C10.8089 8.09747 10.7526 8.05919 10.6904 8.03321C10.6282 8.00723 10.5614 7.99411 10.4941 7.99463Z",
  fill: "#94A3B8"
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 4,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.7823 2.21582H5.21978C2.92078 2.21582 1.05078 4.08582 1.05078 6.38482V7.47882C1.05078 9.77732 2.92078 11.6473 5.21928 11.6473H5.38128L5.11128 13.1158C5.06928 13.3458 5.17028 13.5748 5.36928 13.6988C5.46178 13.7563 5.56478 13.7848 5.66828 13.7848C5.78728 13.7848 5.90578 13.7468 6.00628 13.6718L8.71528 11.6478H10.7818C13.0803 11.6478 14.9503 9.77782 14.9503 7.47932V6.38482C14.9508 4.08582 13.0808 2.21582 10.7823 2.21582ZM14.0508 7.47832C14.0508 9.28082 12.5843 10.7473 10.7818 10.7473H8.56578C8.46878 10.7473 8.37428 10.7788 8.29628 10.8368L6.15078 12.4398L6.36428 11.2783C6.38828 11.1468 6.35278 11.0118 6.26728 10.9088C6.18178 10.8063 6.05528 10.7468 5.92178 10.7468H5.21928C3.41678 10.7468 1.95028 9.28032 1.95028 7.47782V6.38482C1.95028 4.58232 3.41678 3.11582 5.21928 3.11582H10.7818C12.5843 3.11582 14.0508 4.58232 14.0508 6.38482V7.47832Z",
  fill: "#FF9500"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.37244 6.20703C4.97244 6.20703 4.64844 6.53103 4.64844 6.93103C4.64844 7.33103 4.97244 7.65503 5.37244 7.65503C5.77244 7.65503 6.09644 7.33103 6.09644 6.93103C6.09594 6.53103 5.77194 6.20703 5.37244 6.20703Z",
  fill: "#FF9500"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.00134 6.20703C7.60134 6.20703 7.27734 6.53103 7.27734 6.93103C7.27734 7.33103 7.60134 7.65503 8.00134 7.65503C8.40134 7.65503 8.72534 7.33103 8.72534 6.93103C8.72534 6.53103 8.40134 6.20703 8.00134 6.20703Z",
  fill: "#FF9500"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.6302 6.20703C10.2302 6.20703 9.90625 6.53103 9.90625 6.93103C9.90625 7.33103 10.2302 7.65503 10.6302 7.65503C11.0302 7.65503 11.3542 7.33103 11.3542 6.93103C11.3542 6.53103 11.0302 6.20703 10.6302 6.20703Z",
  fill: "#FF9500"
}, null, -1)
const _hoisted_19 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (Boolean(_ctx.status))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.status.id === 2)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
          : (_ctx.status.id === 3)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
            : (_ctx.status.id === 4)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
              : (_ctx.status.id === 5)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13))
                : (_ctx.status.id === 6)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_19))
                  : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}